<template>
  <div>
    <p style="font-size: 18px;">{{$t('profile.donation_payment_method_info')}}</p>
    <div class="flex title-action">
      <span class="h3">{{$t('profile.status')}}</span>
      <span :class="hasValidPaymentMethod ? 'circleTrue' : 'circleFalse'"/>
    </div>
    <div class="flex title-action">
      <h3>{{$t('profile.donation_payment_method')}}</h3>
      <p
        style="font-size: 18px;"
      >&nbsp;{{ stripe && stripe.paymentMethod ? $t('profile.'+stripe.paymentMethod) : ' N/A'}}</p>
    </div>
    <div class="flex title-action">
      <h3>{{$t('profile.donation_sepa_debit')}}</h3>
      <donapp-button
        v-show="hasSepa"
        class="gradient-merchant btn-sm edit-button"
        :text="editIban ? $t('labels.cancel') : $t('labels.edit')"
        :action="editIbanDetails"
      />
      <donapp-button
        v-show="hasSepa && stripe.paymentMethod !== 'sepa' && !editIban"
        class="gradient-merchant btn-sm edit-button"
        :text="$t('profile.donation_set_preferred_payment_method')"
        value="sepa"
        :action="setDefaultPaymentMethod"
      />
    </div>
    <div class="row">
      <div class="cell stripe col-lg-6" v-show="!hasSepa || editIban">
        <div class="row">
          <material-input
            validation="required"
            name="iban-holder"
            :label="$t('iban.holder')"
            v-model="donationIbanHolder"
            :placeholder="$t('iban.holder')"
            class="material-input"
          />
        </div>
        <div class="row">
          <div class="field">
            <div id="donations-stripe-iban-number" class="input empty"></div>
            <label for="stripe-iban-number" data-tid="iban_number_label">{{$t('iban.number')}}</label>
            <div class="baseline"></div>
          </div>
        </div>
      </div>
      <div class="cell stripe col-lg-12 mt17" v-show="!hasSepa || editIban">
        <div class="row">
          <span class="mandate">
            <p-check class="p-icon p-round p-pulse" color="info" v-model="acceptedSepaTerms">
              <i slot="extra" class="icon material-icons">check</i>
              La sottoscrizione del presente mandato comporta l’autorizzazione a Fondazione Italia (FIDo) e Stripe, nostro fornitore del servizio di pagamento, a richiedere alla sua banca l’addebito del suo conto e l’autorizzazione alla sua banca di procedere a tale addebito conformemente alle disposizioni impartite da Fondazione Italia e Stripe. Il debitore ha diritto di ottenere il rimborso dalla propria Banca secondo gli accordi ed alle condizioni che regolano il rapporto con quest’ultima. Se del caso, il rimborso deve essere richiesto nel termine di 8 settimane a decorrere dalla data di addebito in conto.
            </p-check>
          </span>
        </div>
      </div>
      <div class="card-issuer col-lg-12" v-if="hasSepa && !editIban">
        <div class="row issuer">
          <div class="col-md-12">
            <li>{{$t('iban.holder')}}</li>
            <p class="value">{{ sepa.accountHolder }}</p>
          </div>
          <div class="col-md-12">
            <li>{{$t('iban.number')}}</li>
            <p class="value">************{{ sepa.lastDigits }}</p>
          </div>
        </div>
      </div>
    </div>
    <donapp-button
      v-if="!hasSepa || editIban"
      class="gradient-merchant"
      :text="$t('labels.subscribe')"
      value="donation"
      :action="saveIban"
      :disabled="loading"
    />
    <div class="flex title-action">
      <h3>{{$t('profile.donation_credit_card')}}</h3>
      <donapp-button
        v-show="hasCreditCard"
        class="gradient-merchant btn-sm edit-button"
        :text="editCard ? $t('labels.cancel') : $t('labels.edit')"
        :action="editCardDetails"
      />
      <donapp-button
        v-show="hasCreditCard && stripe.paymentMethod !== 'creditCard' && !editCard"
        class="gradient-merchant btn-sm edit-button"
        :text="$t('profile.donation_set_preferred_payment_method')"
        :action="setDefaultPaymentMethod"
        value="creditCard"
      />
    </div>
    <div class="row">
      <div class="cell stripe col-lg-6" v-show="!hasCreditCard || editCard">
        <div class="row">
          <material-input
            validation="required"
            name="card-holder"
            :label="$t('credit_card.holder')"
            v-model="donationCardholder"
            :placeholder="$t('credit_card.holder')"
            class="material-input"
          />
        </div>
        <div class="row">
          <div class="field">
            <div id="donations-stripe-card-number" class="input empty"></div>
            <label
              for="stripe-card-number"
              data-tid="card_number_label"
            >{{$t('credit_card.number')}}</label>
            <div class="baseline"></div>
          </div>
        </div>
        <div class="row">
          <div class="field half-width">
            <div id="donations-stripe-card-expiry" class="input empty"></div>
            <label
              for="stripe-card-expiry"
              data-tid="card_expiry_label"
            >{{$t('credit_card.expire')}}</label>
            <div class="baseline"></div>
          </div>
          <div class="field half-width">
            <div id="donations-stripe-card-cvc" class="input empty"></div>
            <label for="stripe-card-cvc" data-tid="card_cvc_label">{{$t('credit_card.cvc')}}</label>
            <div class="baseline"></div>
          </div>
        </div>
      </div>
      <div class="card-issuer col-lg-12" v-if="hasCreditCard && !editCard">
        <div class="row issuer">
          <div class="col-md-12">
            <li>{{$t('credit_card.holder')}}</li>
            <p class="value">{{ creditCard.cardHolder || '-' }}</p>
          </div>
          <div class="col-md-4">
            <li>{{$t('credit_card.number')}}</li>
            <p class="value">************ {{ creditCard.lastDigits }}</p>
            <li>{{$t('credit_card.brand')}}</li>
            <p class="value">{{ creditCard.brand }}</p>
          </div>
          <div class="col-md-4">
            <li>{{$t('credit_card.expire')}}</li>
            <div class="bank-details">
              <p class="value">{{ creditCard.expMonth + '/' + creditCard.expYear}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <donapp-button
      v-if="!hasCreditCard || editCard"
      class="gradient-merchant"
      :text="editCard ? $t('labels.update') : $t('labels.save')"
      value="donation"
      :action="saveCard"
      :disabled="loading"
    />
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import MaterialInput from '@/components/shared/inputs/Material'
import DonappButton from '@/components/shared/buttons/Button'
import SelectDropDown from '@/components/shared/inputs/SelectDropDown'
import Multiselect from 'vue-multiselect'
import stripe from '../../../services/StripeInitializer'
import apiService from '../../../services/ApiService'

export default {
  name: 'merchant-payment-methods',
  components: {
    MaterialInput,
    DonappButton,
    SelectDropDown,
    Multiselect
  },
  $_veeValidate: {
    validator: 'new' // give me a new validator each time.
  },
  data() {
    return {
      stripeError: undefined,
      complete: false,
      number: false,
      expiry: false,
      cvc: false,
      editCard: false,
      acceptedSepaTerms: false,
      donationCardholder: '',
      donationCardNumberElement: undefined,
      donationCardExpiryElement: undefined,
      donationCardCvcElement: undefined,
      editIban: false,
      donationIbanHolder: '',
      donationIbanNumberElement: undefined,
      loading: false,
      options: {
        style: {
          base: {
            color: '#32325D',
            fontWeight: 500,
            fontSize: '14px',
            fontSmoothing: 'antialiased',
            '::placeholder': {
              color: '#CFD7DF'
            },
            ':-webkit-autofill': {
              color: '#e39f48'
            }
          },
          invalid: {
            color: '#E25950',
            '::placeholder': {
              color: '#FFCCA5'
            }
          }
        }
      }
    }
  },
  mounted: async function() {
    const { cardNumber, cardCvc, cardExpiry, ibanNumber } = stripe.initializeStripeForm('donations')
    this.donationIbanNumberElement = ibanNumber
    this.donationCardNumberElement = cardNumber
    this.donationCardExpiryElement = cardExpiry
    this.donationCardCvcElement = cardCvc
    this.loading = true
    try {
      const { data: result } = await apiService.getProfile('merchants', this.merchant._id)
      if (result.success) this.setPaymentsMethods(result.data.donation.stripe)
    } catch (error) {
      this.error = error.message || this.$i18n.t('errors.something_wrong')
    }
    this.loading = false
  },
  methods: {
    ...mapMutations({
      setPaymentsMethods: 'setPaymentsMethods'
    }),
    async saveCard() {
      this.loading = true
      try {
        let result
        result = await stripe.createToken(this.donationCardNumberElement, {
          name: this.donationCardholder
        })
        if (result.error) throw new Error(result.error.message)
        const newMerchant = await apiService.saveCard(this.merchant._id, result.token.id, result.token.card)
        if (newMerchant.data.success) {
          this.$toasted.success(this.$i18n.t('messages.payment_method_updated'))
          this.setPaymentsMethods(newMerchant.data.data.donation.stripe)
        } else throw new Error(newMerchant.error.message)
      } catch (error) {
        this.$toasted.error(this.$i18n.t('errors.something_wrong') + ': ' + error.message)
      }
      this.donationCardExpiryElement.clear()
      this.donationCardCvcElement.clear()
      this.donationCardholder = ''
      this.donationCardNumberElement.clear()
      this.loading = false
      if (this.editCard) this.editCard = false
    },
    async saveIban() {
      this.loading = true
      try {
        let result
        if (!this.donationIbanHolder) throw new Error(this.$i18n.t('messages.payment_method_complete_form'))
        if (!this.acceptedSepaTerms) throw new Error(this.$$i18n.t('messages.accept_sepa_terms'))
        result = await stripe.createSource(this.donationIbanNumberElement, {
          type: 'sepa_debit',
          currency: 'eur',
          owner: {
            name: this.donationIbanHolder
          },
          mandate: {
            // Automatically send a mandate notification email to your customer
            // once the source is charged.
            notification_method: 'none'
          }
        })
        if (result.error) throw new Error(result.error.message)
        const newMerchant = await apiService.saveIban(this.merchant._id, result.source)
        if (newMerchant.data.success) {
          this.$toasted.success(this.$i18n.t('messages.payment_method_updated'))
          this.setPaymentsMethods(newMerchant.data.data.donation.stripe)
        } else throw new Error(newMerchant.error.message)

        this.donationIbanNumberElement.clear()
        this.donationIbanHolder = ''
        this.acceptedSepaTerms = false
        if (this.editIban) this.editIban = false
      } catch (error) {
        this.$toasted.error(error.message)
      }
      this.loading = false
    },
    editCardDetails: function() {
      this.editCard = !this.editCard
    },
    editIbanDetails: function() {
      this.editIban = !this.editIban
    },
    setDefaultPaymentMethod: async function(method) {
      this.loading = true
      try {
        const newMerchant = await apiService.setDefaultPaymentMethod(this.merchant._id, method)
        if (newMerchant.data.success) {
          this.$toasted.success(this.$i18n.t('messages.payment_method_updated'))
          this.setPaymentsMethods(newMerchant.data.data.donation.stripe)
        } else throw new Error(newMerchant.error.message)
      } catch (error) {
        this.$toasted.error(this.$i18n.t('errors.something_wrong') + ': ' + error.message)
      }
      this.loading = false
    }
  },
  computed: {
    hasCreditCard: function() {
      return this.stripe && this.stripe.creditCard && this.stripe.creditCard.valid
    },
    hasSepa: function() {
      return this.stripe && this.stripe.sepa && this.stripe.sepa.valid
    },
    hasValidPaymentMethod: function() {
      return (this.hasCreditCard && this.stripe.paymentMethod === 'creditCard') || (this.hasSepa && this.stripe.paymentMethod === 'sepa')
    },
    creditCard: function() {
      return this.stripe ? this.stripe.creditCard : null
    },
    sepa: function() {
      return this.stripe ? this.stripe.sepa : null
    },
    ...mapState({
      merchant: state => state.user.loggedRole.merchant,
      stripe: state => (!state.user.loggedRole.merchant.donation ? null : state.user.loggedRole.merchant.donation.stripe)
    })
  }
}
</script>

<style lang="scss" scoped>
@import '../../../scss/config.scss';

.mandate {
  display: inline-flex;
  font-size: 18px;
  line-height: 24px;

  label {
    font-size: 32px;
  }

  i {
    color: $merchantStart;
  }
}

button.btn-sm.edit-button {
  margin-left: 23px;
}

.title-action {
  margin-top: 36px;
  align-items: center;
}

.material-input {
  margin-bottom: 17px;
}

.flex.status {
  align-items: center;
}

h3,
.h3 {
  @include biggestFontSize();
  font-weight: 700;
  line-height: 21px;
  cursor: default;
}

h3 {
  margin: 0;
}

.h3 {
  @include biggestFontSize();
  font-weight: 700;
  line-height: 21px;
  margin-top: 0px;
  margin-bottom: 0px;
  cursor: default;
}

.flex.status .h3 {
  margin-top: 0px;
  margin-bottom: 0px;
}

.field.half-width {
  width: 50%;
}

.stripe .row {
  display: -ms-flexbox;
  display: flex;
  margin: 0 0px 10px;
}

.stripe .field {
  position: relative;
  width: 100%;
  height: 50px;
  margin: 0 0px;
}

.stripe .field.half-width:first-of-type {
  margin-right: 30px;
}

.stripe .field.quarter-width {
  width: calc(25% - 10px);
}

.stripe .baseline {
  position: absolute;
  width: 100%;
  height: 1px;
  left: 0;
  bottom: 0;
  background-color: #cfd7df;
  transition: background-color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.stripe label {
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 8px;
  color: #cfd7df;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  transform-origin: 0 50%;
  cursor: text;
  transition-property: color, transform;
  transition-duration: 0.3s;
  transition-timing-function: cubic-bezier(0.165, 0.84, 0.44, 1);
  pointer-events: none;
  user-select: none;
  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -o-user-select: none;
}

.stripe .input {
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 0;
  padding-bottom: 7px;
  color: #32325d;
  background-color: transparent;
}

.stripe .input::-webkit-input-placeholder {
  color: transparent;
  transition: color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.stripe .input::-moz-placeholder {
  color: transparent;
  transition: color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.stripe .input:-ms-input-placeholder {
  color: transparent;
  transition: color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.stripe .input.StripeElement {
  opacity: 0;
  transition: opacity 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
  will-change: opacity;
}

.stripe .input.focused,
.stripe .input:not(.empty) {
  opacity: 1;
}

.stripe .input.focused::-webkit-input-placeholder,
.stripe .input:not(.empty)::-webkit-input-placeholder {
  color: #cfd7df;
}

.stripe .input.focused::-moz-placeholder,
.stripe .input:not(.empty)::-moz-placeholder {
  color: #cfd7df;
}

.stripe .input.focused:-ms-input-placeholder,
.stripe .input:not(.empty):-ms-input-placeholder {
  color: #cfd7df;
}

.stripe .input.focused + label,
.stripe .input:not(.empty) + label {
  color: #aab7c4;
  transform: scale(0.85) translateY(-25px);
  cursor: default;
}

.stripe .input.focused + label {
  color: #24b47e;
}

.stripe .input.invalid + label {
  color: #ffa27b;
}

.stripe .input.focused + label + .baseline {
  background-color: #24b47e;
}

.stripe .input.focused.invalid + label + .baseline {
  background-color: #e25950;
}

.stripe input,
.stripe button {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  outline: none;
  border-style: none;
}

.stripe input:-webkit-autofill {
  -webkit-text-fill-color: #e39f48;
  transition: background-color 100000000s;
  -webkit-animation: 1ms void-animation-out;
  animation: 1ms void-animation-out;
}

.stripe .StripeElement--webkit-autofill {
  background: transparent !important;
}

.stripe input,
.stripe button {
  -webkit-animation: 1ms void-animation-out;
  animation: 1ms void-animation-out;
}

.stripe input:active {
  background-color: #159570;
}

.stripe .error svg {
  margin-top: 0 !important;
}

.stripe .error svg .base {
  fill: #e25950;
}

.stripe .error svg .glyph {
  fill: #fff;
}

.stripe .error .message {
  color: #e25950;
}

.stripe .success .icon .border {
  stroke: #abe9d2;
}

.stripe .success .icon .checkmark {
  stroke: #24b47e;
}

.stripe .success .title {
  color: #32325d;
  font-size: 16px !important;
}

.stripe .success .message {
  color: #8898aa;
  font-size: 13px !important;
}

.stripe .success .reset path {
  fill: #24b47e;
}

.stripe button {
  display: block;
  width: calc(100% - 30px);
  height: 40px;
  margin: 15px 15px 20px;
  background-color: #24b47e;
  border-radius: 4px;
  color: #fff;
  text-transform: uppercase;
  font-weight: 600;
  cursor: pointer;
}

.material-input {
  font-weight: 500;
}

li {
  list-style: none;
}

.issuer p {
  color: rgba(0, 0, 0, 0.2);
  font-weight: regular;
}

p.value {
  color: #202020;
  font-weight: bold;
}

.header-action {
  margin: auto;
  color: white;
}

.card .title {
  color: $white;
  @include normalFontSize();
  line-height: 14px;
  margin-right: 8px;
  font-weight: normal;
}

.card-issuer {
  min-height: 120px;
}
</style>



// WEBPACK FOOTER //
// src/components/merchants/account/PaymentMethods.vue